// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import router from './router'
import App from './App'
// import auth from '@/auth'
import 'promise-polyfill/src/polyfill'

Vue.config.productionTip = false

Vue.filter('nFormatter', function (value, digits = 2) {
  if (!value) return ''

  const si = [
    { value: 1, symbol: '' },
    { value: 1E3, symbol: 'k' },
    { value: 1E6, symbol: 'm' },
    { value: 1E9, symbol: 'g' },
    { value: 1E12, symbol: 't' },
    { value: 1E15, symbol: 'p' },
    { value: 1E18, symbol: 'e' }
  ]
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/

  let i
  for (i = si.length - 1; i > 0; i--) {
    if (value >= si[i].value) {
      break
    }
  }
  return (value / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol
})

// auth.initialize().then(_ => { Azure auth
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})
// })
/* eslint-disable no-new */



// WEBPACK FOOTER //
// ./src/main.js